import { render, staticRenderFns } from "./CRUDTable2.vue?vue&type=template&id=1cd7f4cc"
import script from "./CRUDTable2.vue?vue&type=script&lang=js"
export * from "./CRUDTable2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports